import {Component, HostBinding} from '@angular/core';
import {UploadService} from "../../services/upload.service";
import {MatProgressBarModule} from "@angular/material/progress-bar";

/** Header for the entire app that shows whether an audio upload is in progress and how much of it has been uploaded */
@Component({
	selector: 'app-upload-progress-header',
	imports: [
		MatProgressBarModule
	],
	templateUrl: './upload-progress-header.component.html',
	styleUrl: './upload-progress-header.component.scss'
})
export class UploadProgressHeaderComponent {
	private readonly amountToSubtract:number = 1;

	constructor(protected uploadService:UploadService) {
	}

	/** Is the nav bar hidden */
	@HostBinding('class.hidden')
	get isHidden() {
		return !this.uploadService.isShown;
	}

	/** The total percentage of upload that has occurred in a percentage out of 100 */
	get progress() {
		let percentage = Math.round(this.uploadService.totalProgress * 100);
		percentage = Math.max(percentage, this.amountToSubtract);
		percentage = Math.min(percentage, 100 - this.amountToSubtract);
		return percentage;
	}
}
